/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ReportTypeRepresentation } from '@veeam-vspc/models/web-controllers';

export type ReportType = ReportTypeRepresentation;
export const ReportType = ReportTypeRepresentation;
